import type {RouteRecordRaw} from 'vue-router';
import type {CommonRouteMeta} from '@/types/common';

const EsignRecipient = () => import('@/views/eSigner/RecipientV2.vue');
const BaseESigner = () => import('@/components/eSigner/index.vue');

export const eSignerRoutes: RouteRecordRaw[] = [
    {
        path: '/signing',
        component: BaseESigner,
        meta: {
            layout: 'Esign',
        } as CommonRouteMeta,
        children: [
            {
                path: 'v2/:envelope_id/:recipient_id',
                component: EsignRecipient,
                name: 'esign.recipient.v2',
                meta: {title: 'eSign Recipient', icon: 'domain', noCache: true, showNavbar: true, layout: 'Esign',},
            },
            {
                // In-person signing kiosk (docs/in-person-signing.md). Static `done`
                // sits above the token route so it never matches as a token.
                path: 'in-person/done',
                component: () => import('@/views/eSigner/InPersonDone.vue'),
                name: 'esign.in_person.done',
                meta: {title: 'Signed', icon: 'domain', noCache: true, showNavbar: false, layout: 'Esign'},
            },
            {
                path: 'in-person/:token',
                component: () => import('@/views/eSigner/InPersonSigning.vue'),
                name: 'esign.in_person',
                meta: {title: 'Sign in person', icon: 'domain', noCache: true, showNavbar: false, layout: 'Esign'},
            },
            {
                path: 'v2/:envelope_id/:recipient_id/sample',
                component: () => import('@/views/eSigner/RecipientV2.vue'),
                name: 'esign.recipient.v2.sample',
                meta: {title: 'eSign Recipient', icon: 'domain', noCache: true, showNavbar: true},
            },
        ],
    },
];

export const eSignerCompleteRoutes: RouteRecordRaw = {
    path: '/signing',
    component: BaseESigner,
    children: [
        {
            path: ':envelope_id/:recipient_id/complete',
            component: () => import('@/views/eSigner/RecipientComplete.vue'),
            name: 'esign.recipient.complete',
            meta: {title: 'eSign Recipient Complete', icon: 'domain', noCache: true},
        },
    ],
    meta: {hidden: true, noCache: false} as CommonRouteMeta
};
